/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ref: NonNullable<unknown> }} Partner_Detail_Org_RefInputs */



/**
* | output |
* | --- |
* | "ref {ref}" |
*
* @param {Partner_Detail_Org_RefInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_org_ref = /** @type {((inputs: Partner_Detail_Org_RefInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Org_RefInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Kennung ${i?.ref}`)
	return /** @type {LocalizedString} */ (`ref ${i?.ref}`)
});